
    import { computed, defineComponent, type PropType } from 'vue'

    import { useGalleryViewer } from '@/common/composables/gallery-viewer'
    import type { Gallery } from '@/common/models/data/dashboard/media/gallery'

    export default defineComponent({
        props: {
            gallery: {
                type: Object as PropType<Gallery>,
                default: () => null
            }
        },
        setup (props) {
            const entries = computed(() => props.gallery?.images ?? [])

            return {
                ...useGalleryViewer(entries)
            }
        }
    })
